import Boss from "./Boss";

export default class BossSpider extends Boss {
    constructor() {
        super("adversary_spider", Boss.TYPE_SPIDER);

        this.scale.set(0.5);

        this.setIdleAnims(["idle"]);
        this.setAttackAnims(["attack"]);
        this.setDamageAnims(["damage"]);
        this.setDefeatAnims(["defeat"]);
        this.setVictoryAnims(["victory"]);
        this.setEnterAnims(["enter"]);

        this._attackSoundName = "sfx_spider_attack_00";
        this._enterSoundName = "sfx_enter_spider";
    }

    init() {
        super.init(P3.utils.selectRandom(["spider1", "spider2"]));
    }
}